export default __webpack_public_path__ + "static/media/polzovatel.67320fa0.svg";